export enum StatusCodes {
  TAPPED = "T",
  ARRIVE = "L",
  SHIP = "U",
}
